/**
 * La VO — Scroll Reveal Animation
 * Adds 'active' class to .lavo-reveal elements when they enter the viewport
 */
(function () {
    'use strict';

    const revealElements = document.querySelectorAll('.lavo-reveal');

    if (!revealElements.length) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0.15,
            rootMargin: '0px 0px -50px 0px',
        }
    );

    revealElements.forEach((el) => observer.observe(el));
})();
